<template>
    <v-dialog
        v-model="$store.state.dispatch.syncWarning"
        hide-overlay
        persistent
        max-width="600px"
        transition="dialog-bottom-transition"
    >
        <v-card>
            <v-card-title>
                <p style="margin: 0 auto;">Synchronization Warning</p>
            </v-card-title>

            <v-alert
                text
                dense
                color="teal"
                icon="mdi-clock-fast"
                border="left"
                style="margin: 0;padding-left: 30px;"
            >
                <p style="margin: 0;"><strong>{{ Message[0] }}</strong>{{ Message[1] }}</p>
                <p style="margin: 0;">{{ Message[2] }}</p>
                <p style="margin: 0;">{{ Message[3] }}</p>
                <p style="margin: 0;"><strong>{{ Message[4] }}</strong></p>
            </v-alert>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="teal"
                    text
                    @click="$store.state.dispatch.syncWarning = false"
                >
                    Close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
// Imports here

export default {
    props: ['Message'],
    components: {
    },
    data: function () {
        return {
            //variables: [],
            //here: true,
            //...
        }
    },
    mounted() {
        //this.functionsForMountedHere();
    },
    methods: {
        /*functionHere: function() {

        },
        otherFunctionHere: function() {

        }
        */
    },
};
</script>

<style>
/* Styles here */
</style>